import angular from 'angular';

let cursorPagination = angular.module("cursorPagination", ["cursorPaginationHtmlTemplate"])
    .config(['$qProvider', 'languageResourceProvider', function ($qProvider, languageResourceProvider) {
        /**
            * This here for mask error coming from Angular 1.6.3 upgrade
            * http://stackoverflow.com/questions/41281515/possibly-unhandled-rejection-in-angular-1-6/41283198#41283198
            */
        if (angular.isFunction($qProvider.errorOnUnhandledRejections)) {
            $qProvider.errorOnUnhandledRejections(false);
        }
        languageResourceProvider.setLanguageKeysFromFile(Roblox.Lang.ControlsResources);
    }]);

export default cursorPagination;